// extracted by mini-css-extract-plugin
export default {"productGrid":"h5-z","centerLink":"i5-z","productSection":"j5-z","item":"k5-z","ctaButton":"l5-z"};